import { AlertTriangleIcon } from 'lucide-react';
import { useEffect, type ReactElement } from 'react';

import { useChatStore } from '../ChatProvider';

export function ErrorOverlay(): ReactElement | null {
  const visible = useChatStore((s) => s.ui.errorOverlay.visible);
  const countdown = useChatStore((s) => s.ui.errorOverlay.countdown);
  const tick = useChatStore((s) => s.tickErrorOverlay);

  useEffect(() => {
    if (!visible) return;
    const id = window.setInterval(() => {
      tick();
    }, 1000);
    return () => {
      window.clearInterval(id);
    };
  }, [visible, tick]);

  if (!visible) return null;

  return (
    <div
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="chat-error-overlay-title"
      data-slot="chat-error-overlay"
      className="motion-safe:animate-in motion-safe:fade-in motion-safe:duration-200 absolute inset-0 z-50 flex flex-col items-center justify-center bg-background/70 p-6 text-center backdrop-blur-md"
    >
      <div className="bg-card text-card-foreground border-border motion-safe:animate-in motion-safe:zoom-in-95 motion-safe:duration-200 flex max-w-[20rem] flex-col items-center gap-3 rounded-2xl border p-6 shadow-2xl">
        <span className="bg-destructive/10 text-destructive flex size-12 items-center justify-center rounded-full">
          <AlertTriangleIcon className="size-6" aria-hidden />
        </span>
        <h3 id="chat-error-overlay-title" className="text-base font-semibold">
          Tivemos um problema
        </h3>
        <p className="text-muted-foreground text-sm">
          Por favor, tente novamente em{' '}
          <strong className="text-foreground tabular-nums">{countdown}s</strong>.
        </p>
      </div>
    </div>
  );
}
